export const TOKEN_STORAGE_KEY = '@Conexa:token'

export const USER_STORAGE_KEY = '@Conexa:user'

export const UF_LIST = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
]
export const SEXES_LIST = [
  {
    label: 'Masculino',
    value: 'M',
  },
  {
    label: 'Feminino',
    value: 'F',
  },
  {
    label: 'Outro',
    value: 'Outro',
  },
]

export const ONDUTY_ID = 8206
